import { render } from "./MonitoringPage.vue?vue&type=template&id=ecc70b64&scoped=true"
import script from "./MonitoringPage.vue?vue&type=script&lang=js"
export * from "./MonitoringPage.vue?vue&type=script&lang=js"

import "./MonitoringPage.vue?vue&type=style&index=0&id=ecc70b64&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc70b64"]])

export default __exports__